<template>
  <div>
    <loadingSeccionesComponent v-if="loading" />
    <v-card outlined :loading="loading" v-else>
      <v-container fluid style="padding-top: 1px; padding-bottom: 1px">
        <v-row dense no-gutters>
          <v-col md="4" v-for="(file, index) in files" :key="index">
            <v-list-item style="padding: 1px">
              <v-list-item-action>
                <menu-item
                  :items="menuItems(file._id)"
                  :id="file._id"
                  @menuAction="menuAction"
                />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ file.nombre }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions style="padding-top: 1px; padding-bottom: 10px">
        <subir-documento :id="idDepara" @documentoCargado="documentoCargado" />
      </v-card-actions>
    </v-card>

    <!-- DIALOG PARA ELIMINAR DOCUMENTO -->
    <v-dialog v-model="eliminarDialog.mostrar" width="400px" persistent>
      <v-card :loading="loading">
        <v-card-title class="headline">Eliminar documento</v-card-title>
        <v-card-text
          >¿Está seguro en eliminar el documento "{{
            eliminarDialog.nombre
          }}"?</v-card-text
        >
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
            color="blue-grey darken-1"
            small
            outlined
            text
            @click="eliminarDialog.mostrar = false"
            >Cancelar</v-btn
          >
          <v-btn
            color="blue-grey darken-1"
            small
            dark
            @click="eliminarDocumento()"
            >Eliminar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

import SubirDocumento from "./subirDocumento.vue";
import MenuItem from "../../menus/MenuItem.vue";

import loadingSeccionesComponent from "./loadingDocumentos.vue";
import {
  cargarDocumentosDeparaService,
  previsualizarDocumentoService,
  eliminarDocumentoService,
} from "./documentosDepara.service";

export default {
  name: "Documentos",
  props: ["id"],
  components: {
    SubirDocumento,
    MenuItem,
    loadingSeccionesComponent,
  },
  computed: {
    ...mapGetters(["httpURL", "sessionToken", "userId"]),
  },
  data: () => ({
    loading: false,
    files: [],
    idDepara: null,
    eliminarDialog: {
      mostrar: false,
      idDocumento: null,
      nombre: null,
    },
  }),
  mounted() {
    this.idDepara = this.$route.params.id;
    this.cargarDocumentos();
  },
  methods: {
    async cargarDocumentos() {
      try {
        this.loading = true;
        const serverResponse = await cargarDocumentosDeparaService(
          this.idDepara
        );
        this.loading = false;

        if (!serverResponse.ok) this.$notificarError(serverResponse.mensaje);
        else {
          this.files = serverResponse.documentos;
          //console.log("Documentos regresados: ", this.files);
        }
      } catch (error) {
        this.loading = false;
        this.$notificarError(error);
      }
    },
    documentoCargado(nuevoDocumento) {
      this.files.push(nuevoDocumento);
    },
    // Revisar
    menuItems(id) {
      let menuItems = [];
      let documento = this.files.find((x) => x._id == id);
      if (documento.documento.type == "application/pdf")
        menuItems.push({
          text: "Previsualizar documento",
          action: "previsualizarDocumento",
        });
      menuItems.push({
        text: "Descargar documento",
        action: "descargarDocumento",
      });
      menuItems.push({
        text: "Eliminar documento",
        action: "eliminarDocumento",
      });
      return menuItems;
    },
    menuAction(action, id) {
      let documento = null;
      switch (action) {
        case "eliminarDocumento":
          documento = this.files.find((x) => x._id == id);
          this.eliminarDialog.idDocumento = id;
          this.eliminarDialog.nombre = documento.nombre;
          this.eliminarDialog.mostrar = true;
          break;
        case "descargarDocumento":
          documento = this.files.find((x) => x._id == id);
          this.descargarDocumento(id, documento.nombre);
          break;
        case "previsualizarDocumento":
          documento = this.files.find((x) => x._id == id);
          this.previsualizarDocumento(id, documento.documento.type);
          break;
      }
      // console.log(action, id);
    },
    async eliminarDocumento() {
      try {
        this.loading = true;
        let idDocumento = this.eliminarDialog.idDocumento;
        const serverResponse = await eliminarDocumentoService(idDocumento);
        this.loading = false;

        if (!serverResponse.ok) this.$notificarError(serverResponse.mensaje);
        else {
          this.$notify({
            group: "gral_notif",
            type: "success",
            duration: 1500,
            speed: 500,
            text: serverResponse.mensaje,
          });

          let index = this.files.findIndex(
            (x) => x._id == this.eliminarDialog.idDocumento
          );
          this.files.splice(index, 1);

          this.eliminarDialog.idDocumento = null;
          this.eliminarDialog.nombre = null;
          this.eliminarDialog.mostrar = false;
        }
      } catch (error) {
        this.loading = false;
        this.$notificarError(error);
      }
    },
    async descargarDocumento(id, nombre) {
      try {
        this.loading = true;
        const serverResponse = await previsualizarDocumentoService(id);
        this.loading = false;

        const url = window.URL.createObjectURL(new Blob([serverResponse]));

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", nombre);
        link.click();
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$notificarError(error);
      }
    },
    async previsualizarDocumento(id, tipo) {
      try {
        this.loading = true;
        const serverResponse = await previsualizarDocumentoService(id);
        this.loading = false;

        const url = window.URL.createObjectURL(
          new Blob([serverResponse], { type: tipo })
        );
        window.open(url);
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$notificarError(error);
      }
    },
  },
};
</script>